import { breakpointSizes } from '../constants';
export const getImageSrcSetSizes = ({ baseVw, xsmall, small, medium, large, xlarge, appendImageSizeWithVw = true, }) => {
    let sizesAttr = '';
    const sizesFactory = (breakpoint, imageSize) => {
        return `${sizesAttr}${sizesAttr && ', '}${breakpoint ? `(max-width: ${breakpoint}px) ` : ''}${imageSize}${appendImageSizeWithVw ? 'vw' : ''}`;
    };
    if (xsmall) {
        sizesAttr = sizesFactory(breakpointSizes.small, xsmall);
    }
    if (small) {
        sizesAttr = sizesFactory(breakpointSizes.medium, small);
    }
    if (medium) {
        sizesAttr = sizesFactory(breakpointSizes.large, medium);
    }
    if (large) {
        sizesAttr = sizesFactory(breakpointSizes.xlarge, large);
    }
    if (xlarge) {
        sizesAttr = sizesFactory(breakpointSizes.xlarge + 1, xlarge);
    }
    if (baseVw) {
        sizesAttr = sizesFactory('', baseVw);
    }
    return sizesAttr;
};
//# sourceMappingURL=getImageSrcSetSizes.js.map